export default "__VITE_ASSET__230bf954__"